import type { BaseServerContext } from '@app/serverMiddleware/AppServerContext'

import { CookieManager } from '@app/services/CookieManager'

import { migrateHostOnlyCookies } from '@app/utils/migrateHostOnlyCookies'

import { ServerCookieStore } from './ServerCookieStore'

/**
 * Builds the per-request server cookie manager. `migrateHostOnlyCookies` runs
 * first because it rewrites `ctx.request.headers.cookie`, which `ServerCookieStore`
 * snapshots in its constructor.
 */
export function createServerCookies(ctx: BaseServerContext): CookieManager {
  migrateHostOnlyCookies(ctx)
  return new CookieManager(new ServerCookieStore(ctx))
}
